import { Chip, ChipProps } from '@mui/material';
import { useMemo } from 'react';
import { CompanyRole } from '../../core/modules/user/interfaces/role';

interface Props {
  isSuperuser: boolean;
  role: CompanyRole;
}

function RoleChip(props: Props) {
  const { isSuperuser, role } = props;

  const chipProps: { label: string; color: ChipProps['color'] } = useMemo(() => {
    if (isSuperuser) {
      return {
        label: 'Super Admin',
        color: 'error',
      };
    }
    
    if (role === CompanyRole.COMPANY_ADMIN) {
      return {
        label: 'Administrador',
        color: 'secondary',
      };
    }

    if (role === CompanyRole.TOMADOR_INVENTARIO) {
      return {
        label: 'Tomador de Inventario',
        color: 'info',
      };
    }

    return {
      label: 'Usuario',
      color: 'success',
    };
  }, [isSuperuser, role]);

  return (
    <Chip 
      color={chipProps.color}
      label={chipProps.label}
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
}

export default RoleChip;